module.exports = __webpack_public_path__ + "img/colgate-max-white.f1221c04.png";